import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import parameters, {
	type userLimitDirectBuyModalContentQuery,
} from './__generated__/userLimitDirectBuyModalContentQuery.graphql';

type UserLimitDirectBuyModalComponent = EntryPointComponent<
	{ userLimitDirectBuyModalContentQuery: userLimitDirectBuyModalContentQuery },
	Record<string, never>,
	{ onClose: (extraInformation?: unknown) => void },
	Record<string, never>
>;

export const entryPoint: EntryPoint<UserLimitDirectBuyModalComponent, { cloudId: string }> =
	createEntryPoint({
		root: JSResourceForInteraction<UserLimitDirectBuyModalComponent>(
			/* webpackChunkName: "@atlaskit-internal_edition-awareness-user-limit-direct-buy-modal" */ './user-limit-direct-buy-modal-content',
			{ moduleId: 'edition-awareness-user-limit-direct-buy-modal' },
		),
		getPreloadProps: ({ cloudId }) => ({
			entryPoints: {},
			extraProps: {},
			queries: {
				userLimitDirectBuyModalContentQuery: {
					parameters,
					variables: { cloudId },
				},
			},
		}),
	});
